export default "__VITE_ASSET__e04e4252__"